import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../config/react-query";
import { useToast } from "../../../hooks/useToast";
import { grappageValidate } from "./actions";

export function useGrappageValidate() {
    const { successToast } = useToast();

    const mutation = useMutation({
        mutationFn: grappageValidate,
        onSuccess: () => successToast("Le grappage du dossier a bien été validé"),
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["folders"],
            });
        },
    });

    return mutation;
}
